var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"none2"},[_c('span',[_vm._v("正在建设中 ！")])])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }